/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from '@repo/graphql-types';

import type { FetchOptions } from 'codegen/fetcher/fetcher.types'
import { fetcher } from 'codegen/fetcher'
import { useQuery, type UseQueryOptions, useMutation, type UseMutationOptions } from '@tanstack/react-query'
export type UserFieldsFragment = { __typename?: 'User', id: string, avatarUrl?: string | null, language: Types.Language, email: string, slug?: string | null, firstName?: string | null, lastName?: string | null, stripeCustomerId: string, roles?: Array<string | null> | null, isTemporary: boolean, isBanned: boolean, bio: string, stripeCustomer?: { __typename?: 'StripeCustomer', id: string, account: Types.StripeAccount } | null, currency: { __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string }, subscriptionAccess: { __typename?: 'SubscriptionAccess', allAccess: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, studioAi: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, studioUnlimited: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, coins: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan } | null } }, flags?: { __typename?: 'UserFlags', isNew?: boolean | null, isGAdsSignup?: boolean | null, identifyUser?: boolean | null, isOnHoldSubscriber?: boolean | null } | null, affiliateInfo?: { __typename?: 'AffiliateInfo', affiliateId: string } | null };

export type UserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', me?: { __typename?: 'AuthResponse', token?: string | null, currency?: { __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null, user?: { __typename?: 'User', id: string, avatarUrl?: string | null, language: Types.Language, email: string, slug?: string | null, firstName?: string | null, lastName?: string | null, stripeCustomerId: string, roles?: Array<string | null> | null, isTemporary: boolean, isBanned: boolean, bio: string, stripeCustomer?: { __typename?: 'StripeCustomer', id: string, account: Types.StripeAccount } | null, currency: { __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string }, subscriptionAccess: { __typename?: 'SubscriptionAccess', allAccess: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, studioAi: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, studioUnlimited: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, coins: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan } | null } }, flags?: { __typename?: 'UserFlags', isNew?: boolean | null, isGAdsSignup?: boolean | null, identifyUser?: boolean | null, isOnHoldSubscriber?: boolean | null } | null, affiliateInfo?: { __typename?: 'AffiliateInfo', affiliateId: string } | null } | null } | null };

export type EditUserProfileMutationVariables = Types.Exact<{
  input: Types.EditUserProfileInput;
}>;


export type EditUserProfileMutation = { __typename?: 'Mutation', editUserProfile: { __typename?: 'EditUserProfileResponse', error?: { __typename?: 'ErrorGrowth', type: Types.ErrorTypeGrowth, description?: string | null } | null } };

export type UploadUserAvatarMutationVariables = Types.Exact<{
  input: Types.UploadUserAvatarInput;
}>;


export type UploadUserAvatarMutation = { __typename?: 'Mutation', uploadUserAvatar: { __typename?: 'UploadUserAvatarResponse', avatarUrl?: string | null, error?: { __typename?: 'ErrorGrowth', type: Types.ErrorTypeGrowth, description?: string | null } | null } };

export type DeleteUserAvatarMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type DeleteUserAvatarMutation = { __typename?: 'Mutation', deleteUserAvatar: { __typename?: 'DeleteUserAvatarResponse', success: boolean, error?: { __typename?: 'ErrorGrowth', type: Types.ErrorTypeGrowth, description?: string | null } | null } };

export type UserAllSubscriptionsTypesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserAllSubscriptionsTypesQuery = { __typename?: 'Query', me?: { __typename?: 'AuthResponse', user?: { __typename?: 'User', subscriptions?: { __typename?: 'Subscriptions', fonts?: boolean | null, crafts?: boolean | null, graphics?: boolean | null, embroidery?: boolean | null, classes?: boolean | null } | null } | null } | null };

export type DeleteUserAccountMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type DeleteUserAccountMutation = { __typename?: 'Mutation', deleteUserAccount: { __typename?: 'DeleteUserAccountResponse', deleted: boolean, error?: { __typename?: 'ErrorGrowth', type: Types.ErrorTypeGrowth, description?: string | null } | null } };

export type LogoutMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: { __typename?: 'LogoutResponse', logout?: { __typename?: 'StatusMessage', success: boolean, message: string } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } | null };

export type UsersEligibleForDeletionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UsersEligibleForDeletionQuery = { __typename?: 'Query', usersEligibleForDeletion?: { __typename?: 'UserEligibleForDeletionResponse', message: string, canBeDeleted: boolean, reasons?: Array<{ __typename?: 'UserEligibleForDeletionReason', title: string, desc: string }> | null } | null };

export type UserBillingDetailsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserBillingDetailsQuery = { __typename?: 'Query', me?: { __typename?: 'AuthResponse', token?: string | null, user?: { __typename?: 'User', id: string, stripeCustomerId: string, firstName?: string | null, lastName?: string | null, email: string, currency: { __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string }, billingDetails: { __typename?: 'BillingDetails', taxId?: string | null, euTaxId: string, address: { __typename?: 'Address', line1: string, line2: string, city: string, state: string, postalCode: string, country: string } } } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } | null };

export type AuthResponseFieldsFragment = { __typename?: 'AuthResponse', token?: string | null, user?: { __typename?: 'User', id: string, avatarUrl?: string | null, language: Types.Language, email: string, slug?: string | null, firstName?: string | null, lastName?: string | null, stripeCustomerId: string, roles?: Array<string | null> | null, isTemporary: boolean, isBanned: boolean, bio: string, stripeCustomer?: { __typename?: 'StripeCustomer', id: string, account: Types.StripeAccount } | null, currency: { __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string }, subscriptionAccess: { __typename?: 'SubscriptionAccess', allAccess: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, studioAi: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, studioUnlimited: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, coins: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan } | null } }, flags?: { __typename?: 'UserFlags', isNew?: boolean | null, isGAdsSignup?: boolean | null, identifyUser?: boolean | null, isOnHoldSubscriber?: boolean | null } | null, affiliateInfo?: { __typename?: 'AffiliateInfo', affiliateId: string } | null } | null };

export type LoginResponseFieldsFragment = { __typename?: 'LoginResponse', token?: string | null, user?: { __typename?: 'User', id: string, avatarUrl?: string | null, language: Types.Language, email: string, slug?: string | null, firstName?: string | null, lastName?: string | null, stripeCustomerId: string, roles?: Array<string | null> | null, isTemporary: boolean, isBanned: boolean, bio: string, stripeCustomer?: { __typename?: 'StripeCustomer', id: string, account: Types.StripeAccount } | null, currency: { __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string }, subscriptionAccess: { __typename?: 'SubscriptionAccess', allAccess: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, studioAi: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, studioUnlimited: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, coins: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan } | null } }, flags?: { __typename?: 'UserFlags', isNew?: boolean | null, isGAdsSignup?: boolean | null, identifyUser?: boolean | null, isOnHoldSubscriber?: boolean | null } | null, affiliateInfo?: { __typename?: 'AffiliateInfo', affiliateId: string } | null } | null };

export type RegisterResponseFieldsFragment = { __typename?: 'RegisterResponse', token?: string | null, user?: { __typename?: 'User', id: string, avatarUrl?: string | null, language: Types.Language, email: string, slug?: string | null, firstName?: string | null, lastName?: string | null, stripeCustomerId: string, roles?: Array<string | null> | null, isTemporary: boolean, isBanned: boolean, bio: string, stripeCustomer?: { __typename?: 'StripeCustomer', id: string, account: Types.StripeAccount } | null, currency: { __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string }, subscriptionAccess: { __typename?: 'SubscriptionAccess', allAccess: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, studioAi: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, studioUnlimited: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, coins: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan } | null } }, flags?: { __typename?: 'UserFlags', isNew?: boolean | null, isGAdsSignup?: boolean | null, identifyUser?: boolean | null, isOnHoldSubscriber?: boolean | null } | null, affiliateInfo?: { __typename?: 'AffiliateInfo', affiliateId: string } | null } | null };

export type UserLocationQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserLocationQuery = { __typename?: 'Query', me?: { __typename?: 'AuthResponse', token?: string | null, user?: { __typename?: 'User', id: string, isTemporary: boolean, location: { __typename?: 'UserLocation', country: Types.CountryCode } } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } | null };

export type UserBlockslistedQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserBlockslistedQuery = { __typename?: 'Query', me?: { __typename?: 'AuthResponse', user?: { __typename?: 'User', isUserBlocklisted: { __typename?: 'IsUserBlocklisted', extensionPopup: boolean } } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } | null };

export type UserCheckEarlyTrialCancelQueryVariables = Types.Exact<{
  stripeCustomerId: Types.Scalars['String']['input'];
}>;


export type UserCheckEarlyTrialCancelQuery = { __typename?: 'Query', userCheckEarlyTrialCancel?: { __typename?: 'UserCheckEarlyTrialCancelResponse', earlyTrialCancel: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } | null };

export type UserEligibleToAutostartQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserEligibleToAutostartQuery = { __typename?: 'Query', me?: { __typename?: 'AuthResponse', user?: { __typename?: 'User', stripeCustomerId: string, id: string, subscriptionAccess: { __typename?: 'SubscriptionAccess', allAccess: { __typename?: 'SubscriptionAccessDetails', isEligibleForAutoStartTrial: boolean, isEligibleForAutoStart: boolean }, studioAi: { __typename?: 'SubscriptionAccessDetails', isEligibleForAutoStartTrial: boolean, isEligibleForAutoStart: boolean }, coins: { __typename?: 'SubscriptionAccessDetails', isEligibleForAutoStartTrial: boolean, isEligibleForAutoStart: boolean } }, stripeCustomer?: { __typename?: 'StripeCustomer', account: Types.StripeAccount, id: string } | null, currency: { __typename?: 'Currency', code?: Types.CurrencyCode | null } } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } | null };

export type UserShippingAddressQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserShippingAddressQuery = { __typename?: 'Query', usersShippingAddress: { __typename?: 'UserShippingAddressResponse', message?: string | null, address?: { __typename?: 'UsersShippingAddress', name: string, address1: string, address2: string, city: string, state: string, postCode: string, country: string } | null } };

export type UserProjectDetailsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserProjectDetailsQuery = { __typename?: 'Query', me?: { __typename?: 'AuthResponse', token?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null };

export type LogInMutationVariables = Types.Exact<{
  input: Types.LoginInput;
}>;


export type LogInMutation = { __typename?: 'Mutation', login?: { __typename?: 'LoginResponse', token?: string | null, challenge?: { __typename?: 'AuthChallenge', type: Types.ChallengeType, otp?: string | null } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null, user?: { __typename?: 'User', id: string, avatarUrl?: string | null, language: Types.Language, email: string, slug?: string | null, firstName?: string | null, lastName?: string | null, stripeCustomerId: string, roles?: Array<string | null> | null, isTemporary: boolean, isBanned: boolean, bio: string, stripeCustomer?: { __typename?: 'StripeCustomer', id: string, account: Types.StripeAccount } | null, currency: { __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string }, subscriptionAccess: { __typename?: 'SubscriptionAccess', allAccess: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, studioAi: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, studioUnlimited: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, coins: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan } | null } }, flags?: { __typename?: 'UserFlags', isNew?: boolean | null, isGAdsSignup?: boolean | null, identifyUser?: boolean | null, isOnHoldSubscriber?: boolean | null } | null, affiliateInfo?: { __typename?: 'AffiliateInfo', affiliateId: string } | null } | null } | null };

export type RegisterMutationVariables = Types.Exact<{
  input: Types.RegisterInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register?: { __typename?: 'RegisterResponse', token?: string | null, challenge?: { __typename?: 'AuthChallenge', type: Types.ChallengeType, otp?: string | null } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null, user?: { __typename?: 'User', id: string, avatarUrl?: string | null, language: Types.Language, email: string, slug?: string | null, firstName?: string | null, lastName?: string | null, stripeCustomerId: string, roles?: Array<string | null> | null, isTemporary: boolean, isBanned: boolean, bio: string, stripeCustomer?: { __typename?: 'StripeCustomer', id: string, account: Types.StripeAccount } | null, currency: { __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string }, subscriptionAccess: { __typename?: 'SubscriptionAccess', allAccess: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, studioAi: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, studioUnlimited: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, coins: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan } | null } }, flags?: { __typename?: 'UserFlags', isNew?: boolean | null, isGAdsSignup?: boolean | null, identifyUser?: boolean | null, isOnHoldSubscriber?: boolean | null } | null, affiliateInfo?: { __typename?: 'AffiliateInfo', affiliateId: string } | null } | null } | null };

export type LostPasswordMutationVariables = Types.Exact<{
  input: Types.LostPasswordInput;
}>;


export type LostPasswordMutation = { __typename?: 'Mutation', lostPassword?: { __typename?: 'LostPasswordResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } | null };

export type ReportJwtAuthOutcomeMutationVariables = Types.Exact<{
  input: Types.JwtAuthOutcomeInput;
}>;


export type ReportJwtAuthOutcomeMutation = { __typename?: 'Mutation', reportJwtAuthOutcome?: { __typename?: 'JwtAuthOutcomeResponse', accepted: boolean } | null };

export type UserAuthQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserAuthQuery = { __typename?: 'Query', me?: { __typename?: 'AuthResponse', token?: string | null, user?: { __typename?: 'User', id: string, isTemporary: boolean } | null } | null };

export type UserSubscriptionsGraphicsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserSubscriptionsGraphicsQuery = { __typename?: 'Query', me?: { __typename?: 'AuthResponse', user?: { __typename?: 'User', subscriptions?: { __typename?: 'Subscriptions', graphics?: boolean | null } | null } | null } | null };

export type UserCurrencyCodeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserCurrencyCodeQuery = { __typename?: 'Query', me?: { __typename?: 'AuthResponse', user?: { __typename?: 'User', currency: { __typename?: 'Currency', code?: Types.CurrencyCode | null } } | null, currency?: { __typename?: 'Currency', code?: Types.CurrencyCode | null } | null } | null };

export type UsersUpdateFlagsMutationVariables = Types.Exact<{
  input: Types.UserUpdateFlagsInput;
}>;


export type UsersUpdateFlagsMutation = { __typename?: 'Mutation', usersUpdateFlags: { __typename?: 'UpdateUserResponse', success?: boolean | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type PublicUserProfileQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;


export type PublicUserProfileQuery = { __typename?: 'Query', publicUserProfile: { __typename?: 'PublicUserProfile', id: string, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, slug?: string | null, displayName?: string | null, shopName?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, superSkill?: string | null, profileUrls?: { __typename?: 'PublicUserProfileUrls', crafter?: string | null, designer?: string | null, teacher?: string | null, theArtistry?: string | null } | null, location: { __typename?: 'UserLocation', country: Types.CountryCode } } };

export type UserFollowersCountQueryVariables = Types.Exact<{
  input: Types.UserFollowersCountInput;
}>;


export type UserFollowersCountQuery = { __typename?: 'Query', userFollowersCount?: { __typename?: 'UserFollowersCountResponse', FollowersCount: number, FollowingCount: number, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } | null };

export type MyAvatarUrlSizesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MyAvatarUrlSizesQuery = { __typename?: 'Query', getMyAccountUserProfile: { __typename?: 'GetMyAccountUserProfileResponse', profile?: { __typename?: 'MyAccountUserProfile', avatarUrl: string, avatarUrlSizes: Array<{ __typename?: 'KeyValuePairs', key: string, value: string }> } | null } };


export const EditUserProfileDocument = `
mutation editUserProfile($input: EditUserProfileInput!) {
  editUserProfile(input: $input) {
    error {
      type
      description
    }
  }
}

`

export const editUserProfileMutationKey = 'editUserProfile'

export function editUserProfileMutationFetcher(variables: EditUserProfileMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<EditUserProfileMutation, EditUserProfileMutationVariables>(EditUserProfileDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useEditUserProfileMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<EditUserProfileMutation, E, EditUserProfileMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<EditUserProfileMutation, E, EditUserProfileMutationVariables, C>({
        ...options,
        mutationKey: [editUserProfileMutationKey],
        mutationFn: (variables: EditUserProfileMutationVariables) => editUserProfileMutationFetcher(variables, fetchOptions),
    })
}

export const UploadUserAvatarDocument = `
mutation uploadUserAvatar($input: UploadUserAvatarInput!) {
  uploadUserAvatar(input: $input) {
    avatarUrl
    error {
      type
      description
    }
  }
}

`

export const uploadUserAvatarMutationKey = 'uploadUserAvatar'

export function uploadUserAvatarMutationFetcher(variables: UploadUserAvatarMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<UploadUserAvatarMutation, UploadUserAvatarMutationVariables>(UploadUserAvatarDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useUploadUserAvatarMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<UploadUserAvatarMutation, E, UploadUserAvatarMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<UploadUserAvatarMutation, E, UploadUserAvatarMutationVariables, C>({
        ...options,
        mutationKey: [uploadUserAvatarMutationKey],
        mutationFn: (variables: UploadUserAvatarMutationVariables) => uploadUserAvatarMutationFetcher(variables, fetchOptions),
    })
}

export const DeleteUserAvatarDocument = `
mutation deleteUserAvatar {
  deleteUserAvatar {
    success
    error {
      type
      description
    }
  }
}

`

export const deleteUserAvatarMutationKey = 'deleteUserAvatar'

export function deleteUserAvatarMutationFetcher(variables?: DeleteUserAvatarMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<DeleteUserAvatarMutation, DeleteUserAvatarMutationVariables>(DeleteUserAvatarDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useDeleteUserAvatarMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<DeleteUserAvatarMutation, E, DeleteUserAvatarMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<DeleteUserAvatarMutation, E, DeleteUserAvatarMutationVariables, C>({
        ...options,
        mutationKey: [deleteUserAvatarMutationKey],
        mutationFn: (variables?: DeleteUserAvatarMutationVariables) => deleteUserAvatarMutationFetcher(variables, fetchOptions),
    })
}

export const DeleteUserAccountDocument = `
mutation deleteUserAccount {
  deleteUserAccount {
    error {
      type
      description
    }
    deleted
  }
}

`

export const deleteUserAccountMutationKey = 'deleteUserAccount'

export function deleteUserAccountMutationFetcher(variables?: DeleteUserAccountMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<DeleteUserAccountMutation, DeleteUserAccountMutationVariables>(DeleteUserAccountDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useDeleteUserAccountMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<DeleteUserAccountMutation, E, DeleteUserAccountMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<DeleteUserAccountMutation, E, DeleteUserAccountMutationVariables, C>({
        ...options,
        mutationKey: [deleteUserAccountMutationKey],
        mutationFn: (variables?: DeleteUserAccountMutationVariables) => deleteUserAccountMutationFetcher(variables, fetchOptions),
    })
}

export const LogoutDocument = `
mutation logout {
  logout {
    logout {
      success
      message
    }
    errors {
      code
      message
    }
  }
}

`

export const logoutMutationKey = 'logout'

export function logoutMutationFetcher(variables?: LogoutMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<LogoutMutation, LogoutMutationVariables>(LogoutDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useLogoutMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<LogoutMutation, E, LogoutMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<LogoutMutation, E, LogoutMutationVariables, C>({
        ...options,
        mutationKey: [logoutMutationKey],
        mutationFn: (variables?: LogoutMutationVariables) => logoutMutationFetcher(variables, fetchOptions),
    })
}

export const LogInDocument = `
mutation logIn($input: LoginInput!) {
  login(input: $input) {
    ...LoginResponseFields
    challenge {
      type
      otp
    }
    errors {
      code
      message
    }
  }
}
fragment UserFields on User {
  id
  avatarUrl
  language
  email
  slug
  firstName
  lastName
  stripeCustomerId
  stripeCustomer {
    id
    account
  }
  roles
  currency {
    code
    symbol
  }
  subscriptionAccess {
    allAccess {
      isSubscribed
      isEligibleForFreeTrial
      isEligibleForYearlyUpgrade
      subscription {
        id
        isTrial
        billingPeriod
        endDate
        nextPaymentDate
      }
    }
    studioAi {
      isSubscribed
      isEligibleForFreeTrial
      isEligibleForYearlyUpgrade
      subscription {
        id
        type
        isTrial
        billingPeriod
        endDate
        nextPaymentDate
      }
    }
    studioUnlimited {
      isSubscribed
      subscription {
        id
        type
        isTrial
        billingPeriod
        endDate
        nextPaymentDate
      }
    }
    coins {
      isSubscribed
      subscription {
        id
        type
      }
    }
  }
  flags {
    isNew
    isGAdsSignup
    identifyUser
    isOnHoldSubscriber
  }
  affiliateInfo {
    affiliateId
  }
  isTemporary
  isBanned
  bio
}
fragment LoginResponseFields on LoginResponse {
  token
  user {
    ...UserFields
  }
}
`

export const logInMutationKey = 'logIn'

export function logInMutationFetcher(variables: LogInMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<LogInMutation, LogInMutationVariables>(LogInDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useLogInMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<LogInMutation, E, LogInMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<LogInMutation, E, LogInMutationVariables, C>({
        ...options,
        mutationKey: [logInMutationKey],
        mutationFn: (variables: LogInMutationVariables) => logInMutationFetcher(variables, fetchOptions),
    })
}

export const RegisterDocument = `
mutation register($input: RegisterInput!) {
  register(input: $input) {
    ...RegisterResponseFields
    challenge {
      type
      otp
    }
    errors {
      code
      message
    }
  }
}
fragment UserFields on User {
  id
  avatarUrl
  language
  email
  slug
  firstName
  lastName
  stripeCustomerId
  stripeCustomer {
    id
    account
  }
  roles
  currency {
    code
    symbol
  }
  subscriptionAccess {
    allAccess {
      isSubscribed
      isEligibleForFreeTrial
      isEligibleForYearlyUpgrade
      subscription {
        id
        isTrial
        billingPeriod
        endDate
        nextPaymentDate
      }
    }
    studioAi {
      isSubscribed
      isEligibleForFreeTrial
      isEligibleForYearlyUpgrade
      subscription {
        id
        type
        isTrial
        billingPeriod
        endDate
        nextPaymentDate
      }
    }
    studioUnlimited {
      isSubscribed
      subscription {
        id
        type
        isTrial
        billingPeriod
        endDate
        nextPaymentDate
      }
    }
    coins {
      isSubscribed
      subscription {
        id
        type
      }
    }
  }
  flags {
    isNew
    isGAdsSignup
    identifyUser
    isOnHoldSubscriber
  }
  affiliateInfo {
    affiliateId
  }
  isTemporary
  isBanned
  bio
}
fragment RegisterResponseFields on RegisterResponse {
  token
  user {
    ...UserFields
  }
}
`

export const registerMutationKey = 'register'

export function registerMutationFetcher(variables: RegisterMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<RegisterMutation, RegisterMutationVariables>(RegisterDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useRegisterMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<RegisterMutation, E, RegisterMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<RegisterMutation, E, RegisterMutationVariables, C>({
        ...options,
        mutationKey: [registerMutationKey],
        mutationFn: (variables: RegisterMutationVariables) => registerMutationFetcher(variables, fetchOptions),
    })
}

export const LostPasswordDocument = `
mutation lostPassword($input: LostPasswordInput!) {
  lostPassword(input: $input) {
    success
    errors {
      code
      message
    }
  }
}

`

export const lostPasswordMutationKey = 'lostPassword'

export function lostPasswordMutationFetcher(variables: LostPasswordMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<LostPasswordMutation, LostPasswordMutationVariables>(LostPasswordDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useLostPasswordMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<LostPasswordMutation, E, LostPasswordMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<LostPasswordMutation, E, LostPasswordMutationVariables, C>({
        ...options,
        mutationKey: [lostPasswordMutationKey],
        mutationFn: (variables: LostPasswordMutationVariables) => lostPasswordMutationFetcher(variables, fetchOptions),
    })
}

export const ReportJwtAuthOutcomeDocument = `
mutation reportJwtAuthOutcome($input: JwtAuthOutcomeInput!) {
  reportJwtAuthOutcome(input: $input) {
    accepted
  }
}

`

export const reportJwtAuthOutcomeMutationKey = 'reportJwtAuthOutcome'

export function reportJwtAuthOutcomeMutationFetcher(variables: ReportJwtAuthOutcomeMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ReportJwtAuthOutcomeMutation, ReportJwtAuthOutcomeMutationVariables>(ReportJwtAuthOutcomeDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useReportJwtAuthOutcomeMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ReportJwtAuthOutcomeMutation, E, ReportJwtAuthOutcomeMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ReportJwtAuthOutcomeMutation, E, ReportJwtAuthOutcomeMutationVariables, C>({
        ...options,
        mutationKey: [reportJwtAuthOutcomeMutationKey],
        mutationFn: (variables: ReportJwtAuthOutcomeMutationVariables) => reportJwtAuthOutcomeMutationFetcher(variables, fetchOptions),
    })
}

export const UsersUpdateFlagsDocument = `
mutation usersUpdateFlags($input: UserUpdateFlagsInput!) {
  usersUpdateFlags(input: $input) {
    success
    errors {
      code
      message
    }
  }
}

`

export const usersUpdateFlagsMutationKey = 'usersUpdateFlags'

export function usersUpdateFlagsMutationFetcher(variables: UsersUpdateFlagsMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<UsersUpdateFlagsMutation, UsersUpdateFlagsMutationVariables>(UsersUpdateFlagsDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useUsersUpdateFlagsMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<UsersUpdateFlagsMutation, E, UsersUpdateFlagsMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<UsersUpdateFlagsMutation, E, UsersUpdateFlagsMutationVariables, C>({
        ...options,
        mutationKey: [usersUpdateFlagsMutationKey],
        mutationFn: (variables: UsersUpdateFlagsMutationVariables) => usersUpdateFlagsMutationFetcher(variables, fetchOptions),
    })
}

export const UserDocument = `
query user {
  me {
    ...AuthResponseFields
    currency {
      code
      symbol
    }
    errors {
      code
      message
    }
  }
}
fragment UserFields on User {
  id
  avatarUrl
  language
  email
  slug
  firstName
  lastName
  stripeCustomerId
  stripeCustomer {
    id
    account
  }
  roles
  currency {
    code
    symbol
  }
  subscriptionAccess {
    allAccess {
      isSubscribed
      isEligibleForFreeTrial
      isEligibleForYearlyUpgrade
      subscription {
        id
        isTrial
        billingPeriod
        endDate
        nextPaymentDate
      }
    }
    studioAi {
      isSubscribed
      isEligibleForFreeTrial
      isEligibleForYearlyUpgrade
      subscription {
        id
        type
        isTrial
        billingPeriod
        endDate
        nextPaymentDate
      }
    }
    studioUnlimited {
      isSubscribed
      subscription {
        id
        type
        isTrial
        billingPeriod
        endDate
        nextPaymentDate
      }
    }
    coins {
      isSubscribed
      subscription {
        id
        type
      }
    }
  }
  flags {
    isNew
    isGAdsSignup
    identifyUser
    isOnHoldSubscriber
  }
  affiliateInfo {
    affiliateId
  }
  isTemporary
  isBanned
  bio
}
fragment AuthResponseFields on AuthResponse {
  token
  user {
    ...UserFields
  }
}
`

export const userQueryRootKey = 'user'

export function userQueryFetcher(variables?: UserQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UserQuery, UserQueryVariables>(UserDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function userQueryKey(variables?: UserQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [userQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function userQueryOptions(
    variables?: UserQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UserQuery, unknown, UserQuery, (UserQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: userQueryKey(variables, fetchOptions),
        queryFn: userQueryFetcher(variables, fetchOptions),
    }
}

export function useUserQuery<D = UserQuery, E = unknown>(
    variables?: UserQueryVariables,
    options?: Omit<UseQueryOptions<UserQuery, E, D, (UserQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UserQuery, E, D, (UserQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...userQueryOptions(variables, fetchOptions),
    })
}

export const UserAllSubscriptionsTypesDocument = `
query userAllSubscriptionsTypes {
  me {
    user {
      subscriptions {
        fonts
        crafts
        graphics
        embroidery
        classes
      }
    }
  }
}

`

export const userAllSubscriptionsTypesQueryRootKey = 'userAllSubscriptionsTypes'

export function userAllSubscriptionsTypesQueryFetcher(variables?: UserAllSubscriptionsTypesQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UserAllSubscriptionsTypesQuery, UserAllSubscriptionsTypesQueryVariables>(UserAllSubscriptionsTypesDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function userAllSubscriptionsTypesQueryKey(variables?: UserAllSubscriptionsTypesQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [userAllSubscriptionsTypesQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function userAllSubscriptionsTypesQueryOptions(
    variables?: UserAllSubscriptionsTypesQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UserAllSubscriptionsTypesQuery, unknown, UserAllSubscriptionsTypesQuery, (UserAllSubscriptionsTypesQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: userAllSubscriptionsTypesQueryKey(variables, fetchOptions),
        queryFn: userAllSubscriptionsTypesQueryFetcher(variables, fetchOptions),
    }
}

export function useUserAllSubscriptionsTypesQuery<D = UserAllSubscriptionsTypesQuery, E = unknown>(
    variables?: UserAllSubscriptionsTypesQueryVariables,
    options?: Omit<UseQueryOptions<UserAllSubscriptionsTypesQuery, E, D, (UserAllSubscriptionsTypesQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UserAllSubscriptionsTypesQuery, E, D, (UserAllSubscriptionsTypesQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...userAllSubscriptionsTypesQueryOptions(variables, fetchOptions),
    })
}

export const UsersEligibleForDeletionDocument = `
query usersEligibleForDeletion {
  usersEligibleForDeletion {
    message
    canBeDeleted
    reasons {
      title
      desc
    }
  }
}

`

export const usersEligibleForDeletionQueryRootKey = 'usersEligibleForDeletion'

export function usersEligibleForDeletionQueryFetcher(variables?: UsersEligibleForDeletionQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UsersEligibleForDeletionQuery, UsersEligibleForDeletionQueryVariables>(UsersEligibleForDeletionDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function usersEligibleForDeletionQueryKey(variables?: UsersEligibleForDeletionQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [usersEligibleForDeletionQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function usersEligibleForDeletionQueryOptions(
    variables?: UsersEligibleForDeletionQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UsersEligibleForDeletionQuery, unknown, UsersEligibleForDeletionQuery, (UsersEligibleForDeletionQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: usersEligibleForDeletionQueryKey(variables, fetchOptions),
        queryFn: usersEligibleForDeletionQueryFetcher(variables, fetchOptions),
    }
}

export function useUsersEligibleForDeletionQuery<D = UsersEligibleForDeletionQuery, E = unknown>(
    variables?: UsersEligibleForDeletionQueryVariables,
    options?: Omit<UseQueryOptions<UsersEligibleForDeletionQuery, E, D, (UsersEligibleForDeletionQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UsersEligibleForDeletionQuery, E, D, (UsersEligibleForDeletionQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...usersEligibleForDeletionQueryOptions(variables, fetchOptions),
    })
}

export const UserBillingDetailsDocument = `
query userBillingDetails {
  me {
    token
    user {
      currency {
        code
        symbol
      }
      id
      stripeCustomerId
      firstName
      lastName
      email
      billingDetails {
        taxId
        euTaxId
        address {
          line1
          line2
          city
          state
          postalCode
          country
        }
      }
    }
    errors {
      code
      message
    }
  }
}

`

export const userBillingDetailsQueryRootKey = 'userBillingDetails'

export function userBillingDetailsQueryFetcher(variables?: UserBillingDetailsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UserBillingDetailsQuery, UserBillingDetailsQueryVariables>(UserBillingDetailsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function userBillingDetailsQueryKey(variables?: UserBillingDetailsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [userBillingDetailsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function userBillingDetailsQueryOptions(
    variables?: UserBillingDetailsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UserBillingDetailsQuery, unknown, UserBillingDetailsQuery, (UserBillingDetailsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: userBillingDetailsQueryKey(variables, fetchOptions),
        queryFn: userBillingDetailsQueryFetcher(variables, fetchOptions),
    }
}

export function useUserBillingDetailsQuery<D = UserBillingDetailsQuery, E = unknown>(
    variables?: UserBillingDetailsQueryVariables,
    options?: Omit<UseQueryOptions<UserBillingDetailsQuery, E, D, (UserBillingDetailsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UserBillingDetailsQuery, E, D, (UserBillingDetailsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...userBillingDetailsQueryOptions(variables, fetchOptions),
    })
}

export const UserLocationDocument = `
query userLocation {
  me {
    token
    user {
      id
      isTemporary
      location {
        country
      }
    }
    errors {
      code
      message
    }
  }
}

`

export const userLocationQueryRootKey = 'userLocation'

export function userLocationQueryFetcher(variables?: UserLocationQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UserLocationQuery, UserLocationQueryVariables>(UserLocationDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function userLocationQueryKey(variables?: UserLocationQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [userLocationQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function userLocationQueryOptions(
    variables?: UserLocationQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UserLocationQuery, unknown, UserLocationQuery, (UserLocationQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: userLocationQueryKey(variables, fetchOptions),
        queryFn: userLocationQueryFetcher(variables, fetchOptions),
    }
}

export function useUserLocationQuery<D = UserLocationQuery, E = unknown>(
    variables?: UserLocationQueryVariables,
    options?: Omit<UseQueryOptions<UserLocationQuery, E, D, (UserLocationQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UserLocationQuery, E, D, (UserLocationQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...userLocationQueryOptions(variables, fetchOptions),
    })
}

export const UserBlockslistedDocument = `
query userBlockslisted {
  me {
    user {
      isUserBlocklisted {
        extensionPopup
      }
    }
    errors {
      code
      message
    }
  }
}

`

export const userBlockslistedQueryRootKey = 'userBlockslisted'

export function userBlockslistedQueryFetcher(variables?: UserBlockslistedQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UserBlockslistedQuery, UserBlockslistedQueryVariables>(UserBlockslistedDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function userBlockslistedQueryKey(variables?: UserBlockslistedQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [userBlockslistedQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function userBlockslistedQueryOptions(
    variables?: UserBlockslistedQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UserBlockslistedQuery, unknown, UserBlockslistedQuery, (UserBlockslistedQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: userBlockslistedQueryKey(variables, fetchOptions),
        queryFn: userBlockslistedQueryFetcher(variables, fetchOptions),
    }
}

export function useUserBlockslistedQuery<D = UserBlockslistedQuery, E = unknown>(
    variables?: UserBlockslistedQueryVariables,
    options?: Omit<UseQueryOptions<UserBlockslistedQuery, E, D, (UserBlockslistedQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UserBlockslistedQuery, E, D, (UserBlockslistedQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...userBlockslistedQueryOptions(variables, fetchOptions),
    })
}

export const UserCheckEarlyTrialCancelDocument = `
query userCheckEarlyTrialCancel($stripeCustomerId: String!) {
  userCheckEarlyTrialCancel(input: {stripeCustomerId: $stripeCustomerId}) {
    earlyTrialCancel
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const userCheckEarlyTrialCancelQueryRootKey = 'userCheckEarlyTrialCancel'

export function userCheckEarlyTrialCancelQueryFetcher(variables: UserCheckEarlyTrialCancelQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UserCheckEarlyTrialCancelQuery, UserCheckEarlyTrialCancelQueryVariables>(UserCheckEarlyTrialCancelDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function userCheckEarlyTrialCancelQueryKey(variables: UserCheckEarlyTrialCancelQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [userCheckEarlyTrialCancelQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function userCheckEarlyTrialCancelQueryOptions(
    variables: UserCheckEarlyTrialCancelQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UserCheckEarlyTrialCancelQuery, unknown, UserCheckEarlyTrialCancelQuery, (UserCheckEarlyTrialCancelQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: userCheckEarlyTrialCancelQueryKey(variables, fetchOptions),
        queryFn: userCheckEarlyTrialCancelQueryFetcher(variables, fetchOptions),
    }
}

export function useUserCheckEarlyTrialCancelQuery<D = UserCheckEarlyTrialCancelQuery, E = unknown>(
    variables: UserCheckEarlyTrialCancelQueryVariables,
    options?: Omit<UseQueryOptions<UserCheckEarlyTrialCancelQuery, E, D, (UserCheckEarlyTrialCancelQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UserCheckEarlyTrialCancelQuery, E, D, (UserCheckEarlyTrialCancelQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...userCheckEarlyTrialCancelQueryOptions(variables, fetchOptions),
    })
}

export const UserEligibleToAutostartDocument = `
query userEligibleToAutostart {
  me {
    user {
      subscriptionAccess {
        allAccess {
          isEligibleForAutoStartTrial
          isEligibleForAutoStart
        }
        studioAi {
          isEligibleForAutoStartTrial
          isEligibleForAutoStart
        }
        coins {
          isEligibleForAutoStartTrial
          isEligibleForAutoStart
        }
      }
      stripeCustomerId
      stripeCustomer {
        account
        id
      }
      id
      currency {
        code
      }
    }
    errors {
      code
      message
    }
  }
}

`

export const userEligibleToAutostartQueryRootKey = 'userEligibleToAutostart'

export function userEligibleToAutostartQueryFetcher(variables?: UserEligibleToAutostartQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UserEligibleToAutostartQuery, UserEligibleToAutostartQueryVariables>(UserEligibleToAutostartDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function userEligibleToAutostartQueryKey(variables?: UserEligibleToAutostartQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [userEligibleToAutostartQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function userEligibleToAutostartQueryOptions(
    variables?: UserEligibleToAutostartQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UserEligibleToAutostartQuery, unknown, UserEligibleToAutostartQuery, (UserEligibleToAutostartQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: userEligibleToAutostartQueryKey(variables, fetchOptions),
        queryFn: userEligibleToAutostartQueryFetcher(variables, fetchOptions),
    }
}

export function useUserEligibleToAutostartQuery<D = UserEligibleToAutostartQuery, E = unknown>(
    variables?: UserEligibleToAutostartQueryVariables,
    options?: Omit<UseQueryOptions<UserEligibleToAutostartQuery, E, D, (UserEligibleToAutostartQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UserEligibleToAutostartQuery, E, D, (UserEligibleToAutostartQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...userEligibleToAutostartQueryOptions(variables, fetchOptions),
    })
}

export const UserShippingAddressDocument = `
query userShippingAddress {
  usersShippingAddress {
    address {
      name
      address1
      address2
      city
      state
      postCode
      country
    }
    message
  }
}

`

export const userShippingAddressQueryRootKey = 'userShippingAddress'

export function userShippingAddressQueryFetcher(variables?: UserShippingAddressQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UserShippingAddressQuery, UserShippingAddressQueryVariables>(UserShippingAddressDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function userShippingAddressQueryKey(variables?: UserShippingAddressQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [userShippingAddressQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function userShippingAddressQueryOptions(
    variables?: UserShippingAddressQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UserShippingAddressQuery, unknown, UserShippingAddressQuery, (UserShippingAddressQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: userShippingAddressQueryKey(variables, fetchOptions),
        queryFn: userShippingAddressQueryFetcher(variables, fetchOptions),
    }
}

export function useUserShippingAddressQuery<D = UserShippingAddressQuery, E = unknown>(
    variables?: UserShippingAddressQueryVariables,
    options?: Omit<UseQueryOptions<UserShippingAddressQuery, E, D, (UserShippingAddressQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UserShippingAddressQuery, E, D, (UserShippingAddressQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...userShippingAddressQueryOptions(variables, fetchOptions),
    })
}

export const UserProjectDetailsDocument = `
query userProjectDetails {
  me {
    token
    user {
      id
      firstName
      lastName
    }
  }
}

`

export const userProjectDetailsQueryRootKey = 'userProjectDetails'

export function userProjectDetailsQueryFetcher(variables?: UserProjectDetailsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UserProjectDetailsQuery, UserProjectDetailsQueryVariables>(UserProjectDetailsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function userProjectDetailsQueryKey(variables?: UserProjectDetailsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [userProjectDetailsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function userProjectDetailsQueryOptions(
    variables?: UserProjectDetailsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UserProjectDetailsQuery, unknown, UserProjectDetailsQuery, (UserProjectDetailsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: userProjectDetailsQueryKey(variables, fetchOptions),
        queryFn: userProjectDetailsQueryFetcher(variables, fetchOptions),
    }
}

export function useUserProjectDetailsQuery<D = UserProjectDetailsQuery, E = unknown>(
    variables?: UserProjectDetailsQueryVariables,
    options?: Omit<UseQueryOptions<UserProjectDetailsQuery, E, D, (UserProjectDetailsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UserProjectDetailsQuery, E, D, (UserProjectDetailsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...userProjectDetailsQueryOptions(variables, fetchOptions),
    })
}

export const UserAuthDocument = `
query userAuth {
  me {
    token
    user {
      id
      isTemporary
    }
  }
}

`

export const userAuthQueryRootKey = 'userAuth'

export function userAuthQueryFetcher(variables?: UserAuthQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UserAuthQuery, UserAuthQueryVariables>(UserAuthDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function userAuthQueryKey(variables?: UserAuthQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [userAuthQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function userAuthQueryOptions(
    variables?: UserAuthQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UserAuthQuery, unknown, UserAuthQuery, (UserAuthQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: userAuthQueryKey(variables, fetchOptions),
        queryFn: userAuthQueryFetcher(variables, fetchOptions),
    }
}

export function useUserAuthQuery<D = UserAuthQuery, E = unknown>(
    variables?: UserAuthQueryVariables,
    options?: Omit<UseQueryOptions<UserAuthQuery, E, D, (UserAuthQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UserAuthQuery, E, D, (UserAuthQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...userAuthQueryOptions(variables, fetchOptions),
    })
}

export const UserSubscriptionsGraphicsDocument = `
query userSubscriptionsGraphics {
  me {
    user {
      subscriptions {
        graphics
      }
    }
  }
}

`

export const userSubscriptionsGraphicsQueryRootKey = 'userSubscriptionsGraphics'

export function userSubscriptionsGraphicsQueryFetcher(variables?: UserSubscriptionsGraphicsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UserSubscriptionsGraphicsQuery, UserSubscriptionsGraphicsQueryVariables>(UserSubscriptionsGraphicsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function userSubscriptionsGraphicsQueryKey(variables?: UserSubscriptionsGraphicsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [userSubscriptionsGraphicsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function userSubscriptionsGraphicsQueryOptions(
    variables?: UserSubscriptionsGraphicsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UserSubscriptionsGraphicsQuery, unknown, UserSubscriptionsGraphicsQuery, (UserSubscriptionsGraphicsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: userSubscriptionsGraphicsQueryKey(variables, fetchOptions),
        queryFn: userSubscriptionsGraphicsQueryFetcher(variables, fetchOptions),
    }
}

export function useUserSubscriptionsGraphicsQuery<D = UserSubscriptionsGraphicsQuery, E = unknown>(
    variables?: UserSubscriptionsGraphicsQueryVariables,
    options?: Omit<UseQueryOptions<UserSubscriptionsGraphicsQuery, E, D, (UserSubscriptionsGraphicsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UserSubscriptionsGraphicsQuery, E, D, (UserSubscriptionsGraphicsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...userSubscriptionsGraphicsQueryOptions(variables, fetchOptions),
    })
}

export const UserCurrencyCodeDocument = `
query userCurrencyCode {
  me {
    user {
      currency {
        code
      }
    }
    currency {
      code
    }
  }
}

`

export const userCurrencyCodeQueryRootKey = 'userCurrencyCode'

export function userCurrencyCodeQueryFetcher(variables?: UserCurrencyCodeQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UserCurrencyCodeQuery, UserCurrencyCodeQueryVariables>(UserCurrencyCodeDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function userCurrencyCodeQueryKey(variables?: UserCurrencyCodeQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [userCurrencyCodeQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function userCurrencyCodeQueryOptions(
    variables?: UserCurrencyCodeQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UserCurrencyCodeQuery, unknown, UserCurrencyCodeQuery, (UserCurrencyCodeQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: userCurrencyCodeQueryKey(variables, fetchOptions),
        queryFn: userCurrencyCodeQueryFetcher(variables, fetchOptions),
    }
}

export function useUserCurrencyCodeQuery<D = UserCurrencyCodeQuery, E = unknown>(
    variables?: UserCurrencyCodeQueryVariables,
    options?: Omit<UseQueryOptions<UserCurrencyCodeQuery, E, D, (UserCurrencyCodeQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UserCurrencyCodeQuery, E, D, (UserCurrencyCodeQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...userCurrencyCodeQueryOptions(variables, fetchOptions),
    })
}

export const PublicUserProfileDocument = `
query publicUserProfile($slug: String!) {
  publicUserProfile(slug: $slug) {
    id
    avatarUrl
    firstName
    lastName
    slug
    displayName
    shopName
    avatarUrl
    profileUrls {
      crafter
      designer
      teacher
      theArtistry
    }
    isCreativeFabrica
    isVerified
    isPremium
    isFollowed
    location {
      country
    }
    following
    isTemporary
    superSkill
  }
}

`

export const publicUserProfileQueryRootKey = 'publicUserProfile'

export function publicUserProfileQueryFetcher(variables: PublicUserProfileQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<PublicUserProfileQuery, PublicUserProfileQueryVariables>(PublicUserProfileDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function publicUserProfileQueryKey(variables: PublicUserProfileQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [publicUserProfileQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function publicUserProfileQueryOptions(
    variables: PublicUserProfileQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<PublicUserProfileQuery, unknown, PublicUserProfileQuery, (PublicUserProfileQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: publicUserProfileQueryKey(variables, fetchOptions),
        queryFn: publicUserProfileQueryFetcher(variables, fetchOptions),
    }
}

export function usePublicUserProfileQuery<D = PublicUserProfileQuery, E = unknown>(
    variables: PublicUserProfileQueryVariables,
    options?: Omit<UseQueryOptions<PublicUserProfileQuery, E, D, (PublicUserProfileQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<PublicUserProfileQuery, E, D, (PublicUserProfileQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...publicUserProfileQueryOptions(variables, fetchOptions),
    })
}

export const UserFollowersCountDocument = `
query userFollowersCount($input: UserFollowersCountInput!) {
  userFollowersCount(input: $input) {
    FollowersCount
    FollowingCount
    errors {
      code
      message
    }
  }
}

`

export const userFollowersCountQueryRootKey = 'userFollowersCount'

export function userFollowersCountQueryFetcher(variables: UserFollowersCountQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UserFollowersCountQuery, UserFollowersCountQueryVariables>(UserFollowersCountDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function userFollowersCountQueryKey(variables: UserFollowersCountQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [userFollowersCountQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function userFollowersCountQueryOptions(
    variables: UserFollowersCountQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UserFollowersCountQuery, unknown, UserFollowersCountQuery, (UserFollowersCountQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: userFollowersCountQueryKey(variables, fetchOptions),
        queryFn: userFollowersCountQueryFetcher(variables, fetchOptions),
    }
}

export function useUserFollowersCountQuery<D = UserFollowersCountQuery, E = unknown>(
    variables: UserFollowersCountQueryVariables,
    options?: Omit<UseQueryOptions<UserFollowersCountQuery, E, D, (UserFollowersCountQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UserFollowersCountQuery, E, D, (UserFollowersCountQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...userFollowersCountQueryOptions(variables, fetchOptions),
    })
}

export const MyAvatarUrlSizesDocument = `
query myAvatarUrlSizes {
  getMyAccountUserProfile {
    profile {
      avatarUrl
      avatarUrlSizes {
        key
        value
      }
    }
  }
}

`

export const myAvatarUrlSizesQueryRootKey = 'myAvatarUrlSizes'

export function myAvatarUrlSizesQueryFetcher(variables?: MyAvatarUrlSizesQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<MyAvatarUrlSizesQuery, MyAvatarUrlSizesQueryVariables>(MyAvatarUrlSizesDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function myAvatarUrlSizesQueryKey(variables?: MyAvatarUrlSizesQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [myAvatarUrlSizesQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function myAvatarUrlSizesQueryOptions(
    variables?: MyAvatarUrlSizesQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<MyAvatarUrlSizesQuery, unknown, MyAvatarUrlSizesQuery, (MyAvatarUrlSizesQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: myAvatarUrlSizesQueryKey(variables, fetchOptions),
        queryFn: myAvatarUrlSizesQueryFetcher(variables, fetchOptions),
    }
}

export function useMyAvatarUrlSizesQuery<D = MyAvatarUrlSizesQuery, E = unknown>(
    variables?: MyAvatarUrlSizesQueryVariables,
    options?: Omit<UseQueryOptions<MyAvatarUrlSizesQuery, E, D, (MyAvatarUrlSizesQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<MyAvatarUrlSizesQuery, E, D, (MyAvatarUrlSizesQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...myAvatarUrlSizesQueryOptions(variables, fetchOptions),
    })
}